var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.workflowErrorSteps.length
      ? _c(
          "div",
          { staticClass: "mb-2" },
          _vm._l(_vm.workflowErrorSteps, function (errStep, ei) {
            return _c(
              "div",
              {
                key: "reveal-wf-err-" + ei + "-" + (errStep.title || ""),
                staticClass: "alert alert-danger py-2 small mb-1",
                attrs: { role: "alert" },
              },
              [
                _c("strong", [_vm._v("Error:")]),
                _vm._v(" " + _vm._s(errStep.title) + " "),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticStyle: { display: "flex", gap: "20px" } }, [
      _c(
        "h4",
        {
          staticClass: "reveal-tab",
          class: { "tab-active": _vm.activeTab === "terms" },
          on: {
            click: function ($event) {
              return _vm.$emit("select-tab", "terms")
            },
          },
        },
        [_vm._v(" Search terms ")]
      ),
      _c(
        "h4",
        {
          staticClass: "reveal-tab",
          class: {
            "tab-active": _vm.activeTab === "data",
            "tab-inactive": !_vm.dataTabEnabled,
          },
          on: {
            click: function ($event) {
              _vm.dataTabEnabled && _vm.$emit("select-tab", "data")
            },
          },
        },
        [_vm._v(" Data ")]
      ),
      _c(
        "h4",
        {
          staticClass: "reveal-tab",
          class: {
            "tab-active": _vm.activeTab === "results",
            "tab-inactive": !_vm.resultsTabEnabled,
          },
          on: {
            click: function ($event) {
              _vm.resultsTabEnabled && _vm.$emit("select-tab", "results")
            },
          },
        },
        [_vm._v(" Results ")]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }